import { render } from "./CustomsAndMediation.vue?vue&type=template&id=40a5bdcd&scoped=true"
import script from "./CustomsAndMediation.vue?vue&type=script&lang=js"
export * from "./CustomsAndMediation.vue?vue&type=script&lang=js"

import "./CustomsAndMediation.vue?vue&type=style&index=0&id=40a5bdcd&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a5bdcd"]])

export default __exports__